import React, { Component } from 'react'

export class Rennovation extends Component {
    render() {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <h1>Page Under Renovation !</h1></div>
        )
    }
}

export default Rennovation